import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import { useEffect, useState } from "react";
import DifficultySelect from "./DifficultySelect";
const { Option } = Select;
interface CarpentryEditableProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: string;
  inputType: "number" | "text";
  record: any;
  index: number;
  form: typeof Form;
  children: React.ReactNode;
  data: any;
  setDataRates: any;
}

const CarpentryEditable: React.FC<CarpentryEditableProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  form,
  record,
  index,
  children,
  data,
  setDataRates,
  ...restProps
}) => {
  const inputNode =
    inputType === "number" ? <InputNumber type="number" /> : <Input />;

  return (
    <>
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Please enter ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    </>
  );
};

export default CarpentryEditable;
